import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    Typography
} from "../../ui/ot";
import PageManagementModal from "./page_management_modal";
import { usePageManagement } from "../controller/page_management_controller";
const PageManagement = ({ prefixTitle = "", self = false, permission_level = null ,showBackgroundImage = false }) => {
    const columns = [
        {
            title: "頁面名稱",
            key: "name_language_data_arr",
            dataIndex: "name_language_data",
            align: "left",
            render: (text, record, index) =>
                (record?.name_language_data || [])?.find(
                    (tmp) => tmp?.language_culture_code === "zh-tw"
                )?.language_culture_value || "-"
        },
        // {
        //     title: "頁面分類",
        //     key: "blog_type_id",
        //     dataIndex: "blog_type_id",
        //     align: "center",
        // },
        {
            title: "選單分類數量",
            key: "page_menu_data",
            dataIndex: "page_menu_data",
            align: "center",
            disabled: true,

            render: (text, record, index) => {
                let page_menu_data = record?.page_menu_data || [];
                let page_menu_data_length = page_menu_data.length;
                if (page_menu_data_length > 0) {
                    return `是，${page_menu_data_length}個選單`;
                } else {
                    return "尚未綁定";
                }
            },
        },
        {
            title: "是否綁定選單",
            key: "permission_page_data",
            dataIndex: "permission_page_data",
            align: "center",
            disabled: true,

            render: (text, record, index) => {
                let permission_page_data = record?.permission_page_data || [];
                let permission_page_data_length = permission_page_data.length;
                if (permission_page_data_length > 0) {
                    return `是，${permission_page_data_length}個選單`;
                } else {
                    return "尚未綁定";
                }
            },
        },
        {
            title: "已設定模板數量",
            key: "count_frontend_component",
            dataIndex: "count_frontend_component",
            align: "center",
            disabled: true,

            render: (text, record, index) => {
                return `${text}個`;
            },
        },
        {
            title: "貼文數量",
            key: "count_blog",
            dataIndex: "count_blog",
            align: "center",
            disabled: true,

            render: (text, record, index) => {
                return `${text}個`;
            },
        },
        {
            title: "頁面瀏覽",
            key: "preview",
            dataIndex: "preview",
            align: "center",
            disabled: true,
            render: (text, record, index) => {
                return (
                    <Row>
                        <Col span={24}>
                            <Button
                                type="link"
                                onClick={() => {
                                    window.open('/officialweb/frontend/previewPage?' + (new URLSearchParams({ page_id: record?.page_id }).toString()))
                                }} style={{
                                    color: "#6EACDA"
                                }}
                            >
                                頁面預覽
                            </Button>
                        </Col>
                    </Row>
                )
            },
        },
        // {
        //     title: "點擊次數",
        //     key: "page",
        //     dataIndex: "page",
        //     align: "left",
        // },
        // {
        //     title: '直播室連結',
        //     key: 'blog_room_data',
        //     dataIndex: 'blog_room_data',
        //     align: 'center',
        //     render: ((text, record, index) => {
        //         return text.map((value) => {
        //             return <Button
        //                 type="link"
        //                 onClick={() => {
        //                     navigate(`/officialweb/admin/audio_recorder/liveAdmin/${value?.room_id}`)
        //                 }}
        //             >
        //                 前往
        //             </Button>
        //         })

        //     })
        // },
        {
            title: "最後編輯時間",
            key: "last_edit_time",
            dataIndex: "last_edit_time",
            align: "center",
        },
        {
            title: "操作",
            valueType: "option",
            key: "option",
            fixed: "right",
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    permission_level === 1 ?
                        <Row wrap={false} gutter={[4, 4]}>
                            <Col>
                                <Button
                                    type="primary"
                                    size={"small"}
                                    style={{
                                        verticalAlign: "middle",
                                        backgroundColor: "#E6E2C3",
                                        color: "black",
                                    }}
                                    onClick={(e) => {
                                        if (self) {
                                            window.open(
                                                `/officialweb/admin/pageSettingSelf/${record?.page_id}`
                                            );
                                        } else {
                                            window.open(
                                                `/officialweb/admin/pageSetting/${record?.page_id}`
                                            );
                                        }
                                    }}
                                >
                                    頁面編排
                                </Button>
                            </Col>
                            {/* <Col>
                            <Button
                                type="primary"
                                size="small"
                                onClick={(e) => {
                                    window.open(
                                        `/officialweb/frontend/${record.name}`
                                    );
                                }}
                            >
                                頁面預覽
                            </Button>
                        </Col> */}
                            <Col>
                                <Popconfirm
                                    title="刪除項目"
                                    description="確定刪除勾選項目?"
                                    onConfirm={() =>
                                        handleDeleteRow(record?.page_id)
                                    }
                                    onCancel={() => { }}
                                >
                                    <Button size="small" type="danger">
                                        刪除
                                    </Button>
                                </Popconfirm>
                            </Col>
                        </Row>
                        : <></>
                );
            },
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [form] = Form.useForm();

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.page_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.page_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.page_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.page_id
                );
                selectRow = selectRow.filter(
                    (row) => row.page_id !== record.page_id
                );
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        form.setFieldsValue({
            ...record,
        });
    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    page_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    page_id: val?.page_id,
                };
            });
        }
        if (data.length > 0) {
            deletePageManagementData(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let newValues = { ...values };
        let permission_page_data = (newValues?.permission_page_data || []).map(
            (val) => {
                return {
                    permission_id: val
                }
            }
        );
        let page_menu_data = (newValues?.page_menu_data || []).map((val) => {
            return { menu_id: val };
        });
        newValues = {
            ...newValues,
            page_menu_data,
            permission_page_data,
        };

        if (axiosMode === "post") {
            delete newValues.page_id;
            postPageManagementData([newValues]);
        } else if (axiosMode === "patch") {
            // patchPageManagementData([values]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        if (axiosMode !== "get") {
            setModalLoading(true);
        }
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useTableColumnsCheck(columns);

    const {
        getPageManagementData,
        getPageManagementSelfData,
        postPageManagementData,
        patchPageManagementData,
        deletePageManagementData,
    } = usePageManagement({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        document.title = `${prefixTitle} | 頁面管理`;
        checkAll();
    }, []);

    return (
        <>
            <PageManagementModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
                showBackgroundImage={showBackgroundImage}
            />
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Typography.Title
                        level={3}
                    >
                        頁面管理
                    </Typography.Title>

                    <ProTableOt
                        actionRef={actionRef}
                        columns={columns}
                        check={check}
                        setCheck={setCheck}
                        rowKey={"page_id"}
                        selections={
                            {
                                // onChange: (index_, data_) => set_data(data_)
                            }
                        }
                        toolBarRender={() => permission_level === 1 ? [
                            <Button
                                type="primary"
                                style={{
                                    color: "#000",
                                    backgroundColor: "#ffedee",
                                }}
                                onClick={(e) => handleAddRow()}
                            >
                                新增頁面
                            </Button>,
                            <Popconfirm
                                title="刪除貼文"
                                description="確定刪除勾選的貼文?"
                                onConfirm={() => handleDeleteRow(13)}
                                onCancel={() => { }}
                            >
                                <Button
                                    type="primary"
                                    style={{
                                        color: "#000",
                                        backgroundColor: "#ffedee",
                                    }}
                                >
                                    刪除頁面
                                </Button>
                            </Popconfirm>,
                        ] : []}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get");
                            let newParams = {};
                            let order = setOrders(sort);
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params?.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key,
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            setPageSize(params?.pageSize ?? 20);

                            return getPageManagementData(newParams);
                            // return []
                        }}
                        pageSize={pageSize}
                        rowSelection={{
                            type: "checkbox",
                            selectedRowKeys: selectedRowKeys,
                            ...rowSelection,
                        }}
                        tableAlertOptionRender={() => {
                            return (
                                <>
                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                </>
                            );
                        }}
                        tableAlertRender={({
                            selectedRowKeys,
                            selectedRows,
                            // onCleanSelected,
                        }) => {
                            return (
                                <span>
                                    已選擇 {selectedRowKeys.length} 項
                                    <a
                                        style={{ marginInlineStart: 8 }}
                                        onClick={onCleanSelected}
                                    >
                                        取消選擇
                                    </a>
                                </span>
                            );
                        }}
                        scroll={{
                            x: "100%",
                        }}
                    />
                </Col>
            </Row>
        </>
    );
};

const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([]);
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    };
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: "DESC",
                });
            } else {
                return JSON.stringify({
                    column: key,
                    type: "ASC",
                });
            }
        });
        return newOrders;
    };
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders,
    };
};
export default PageManagement;
